import { Table } from 'react-bootstrap';
import { useGetStocksQuery } from '../../slices/stocksApiSlice';
import Message from '../../components/Message';
import Loader from '../../components/Loader';

const StockUniqueDates = () => {
  const { data, isLoading, error } = useGetStocksQuery();

  // Extract unique dates
  const uniqueDates = data?.stocks
    ? [...new Set(data.stocks.map((stock) => new Date(stock.date).toLocaleDateString()))]
    : [];

  return (
    <>
      <h1>Unique Stock Dates</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || 'Error fetching stock dates'}</Message>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>DATE</th>
            </tr>
          </thead>
          <tbody>
            {uniqueDates.map((date, index) => (
              <tr key={index}>
                <td>{date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default StockUniqueDates;